<template>
  <section class="py-2">
    <div class="py-4 mb-2 flex flex-col gap-2">
      <h2 v-if="title" class="headline-sm text-tertiary60">{{ title }}</h2>
      <p v-if="subtitle" class="body-lg text-on-surface-variant">{{ subtitle }}</p>
    </div>
    <slot>
      <!-- Content goes here -->
    </slot>
  </section>
</template>

<script>
export default {
  name: 'HomeSection',
  props: {
    title: String,
    subtitle: String,
  },
}
</script>

<style></style>
